<!-- Global EventBus Mixin

     Based on
     https://medium.com/@andrejsabrickis/https-medium-com-andrejsabrickis-create-simple-eventbus-to-communicate-between-vue-js-components-cdc11cd59860

     Rather than exporting a global as in the original, this mixin adds methods
     this.$pub, this.$sub and this.$depub for simpler invocation from components,
     and automatic teardown of subscriptions in beforeDestroy.
  -->

<script>
import eventBus from '../services/eventbus'
import debounce from 'lodash/debounce'

const debouncedPubs = {}

export default {
  methods: {
    $pub(eventName, ...args) {
      eventBus.$emit(eventName, ...args)
    },

    $depub(eventName, ...args) {
      let dp = debouncedPubs[eventName]
      if (!dp) {
        dp = debouncedPubs[eventName] = debounce(
          (...args) => {
            this.$pub(...args)
          },
          500,
          {maxWait: 2000},
        )
      }
      dp(eventName, ...args)
    },

    $sub(eventName, callback) {
      eventBus.$on(eventName, callback)
      this.$once('hook:beforeDestroy', () => {
        eventBus.$off(eventName, callback)
      })
    },
  },
}
</script>
